/** Append (or replace) utm_source=twine.net on an absolute URL. */
export const withTwineUtm = (rawUrl) => {
  if (!rawUrl) return '';
  try {
    const parsed = new URL(rawUrl);
    parsed.searchParams.set('utm_source', 'twine.net');
    return parsed.toString();
  } catch (e) {
    const joiner = rawUrl.includes('?') ? '&' : '?';
    if (/[?&]utm_source=/i.test(rawUrl)) {
      return rawUrl.replace(
        /([?&])utm_source=[^&]*/i,
        '$1utm_source=twine.net'
      );
    }
    return `${rawUrl}${joiner}utm_source=twine.net`;
  }
};
